"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Navigation = require("./Navigation.styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _atoms = require("../../atoms");

var _Link = _interopRequireDefault(require("./Link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Renders a tree of nav items recursively.
 * if passing a child component in as the link the following props can be used:
 *   Item.propTypes = {
 *     id: PropTypes.number,
 *     linkComponent: PropTypes.object, // The child component
 *     active: PropTypes.bool,
 *     children: PropTypes.arrayOf(PropTypes.object),
 *     count: PropTypes.number,
 *     disabled: PropTypes.bool,
 *   }
 * Otherwise (for backwards compatibility) the following props can be used:
 *   Item.propTypes = {
 *     id: PropTypes.number,
 *     url: PropTypes.string,
 *     label: PropTypes.string,
 *     active: PropTypes.bool,
 *     children: PropTypes.arrayOf(PropTypes.object),
 *     index: PropTypes.number,
 *     level: PropTypes.number,
 *     onClick: PropTypes.func,
 *     count: PropTypes.number,
 *     disabled: PropTypes.bool,
 *   }
 * @param {*} param0
 * @returns {Object}
 */
const Item = ({
  url,
  linkComponent = null,
  label,
  active,
  children,
  level,
  count,
  disabled,
  onClick,
  id
}) => {
  const [toggle, setToggle] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    children && children.some(child => child.active) ? setToggle(true) : '';
  }, [children]);

  const handleClick = (e, link) => {
    if (!disabled) {
      onClick(e, link);
    }
  };

  const handleToggle = e => {
    setToggle(!toggle);
    onClick(e);
  };

  const labelWithIndex = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label, " ", count ? /*#__PURE__*/_react.default.createElement("span", {
    className: "count"
  }, "(", count, ")") : null, ' ');

  const caret = toggle ? /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: "UpCaret",
    size: 12
  }) : /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    iconName: "DownCaret",
    size: 12
  });
  const isLeaf = typeof linkComponent == 'object' || typeof url == 'string';
  const hasChildren = Array.isArray(children) && children.length;
  return /*#__PURE__*/_react.default.createElement(_Navigation.StyledLI, {
    className: (0, _classnames.default)({
      active: active,
      ['has-child']: children,
      expanded: toggle,
      ['disabled']: disabled
    })
  }, hasChildren && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    onClick: e => handleToggle(e)
  }, labelWithIndex, caret), /*#__PURE__*/_react.default.createElement(_Navigation.StyledUL, {
    className: (0, _classnames.default)({
      ['child']: children
    }, `level-${level += 1}`)
  }, children.map((link, index) => {
    return /*#__PURE__*/_react.default.createElement(Item, _extends({}, link, {
      key: link.id ? link.id : index,
      index: index,
      onClick: e => handleClick(e, link)
    }));
  }))), isLeaf && !hasChildren &&
  /*#__PURE__*/
  // Including the !hasChildren check here maintains the original functionality for backward compatability
  _react.default.createElement(_Link.default, {
    component: linkComponent,
    url: url,
    label: label,
    id: id,
    handleClick: handleClick
  }));
};

exports.Item = Item;
Item.propTypes = {
  id: _propTypes.default.number,
  linkComponent: _propTypes.default.object,
  url: _propTypes.default.string,
  label: _propTypes.default.string,
  active: _propTypes.default.bool,
  children: _propTypes.default.arrayOf(_propTypes.default.object),
  index: _propTypes.default.number,
  level: _propTypes.default.number,
  onClick: _propTypes.default.func,
  count: _propTypes.default.number,
  disabled: _propTypes.default.bool
};